import React from 'react';
import { connect } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import clsx from 'clsx';
// import Typography from '@material-ui/core/Typography';
// import { useTranslation } from 'react-i18next';
import Workshop from './Workshop';
import Meeting from './Meeting';
import MeetingRequest from './MeetingRequest';
import {
  goToPreviousSubpage,
  setActiveWorkshop,
  goToWorkshops,
} from '../../actions/app';
import CustomPropTypes from '../../helpers/CustomPropTypes';
import BackButton from '../../components/BackButton';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F9FAFA',
    padding: theme.spacing(
      theme.subpageDrawer.paddings.desktop.vertical,
      theme.subpageDrawer.paddings.desktop.horizontal
    ),
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 2,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(
        theme.subpageDrawer.paddings.mobile.vertical,
        theme.subpageDrawer.paddings.mobile.horizontal
      ),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  moduleName: {
    color: theme.palette.darkGrey.main,
    fontFamily: 'Fancy Cut Pro',
    fontWeight: 400,
    fontSize: 40,
    lineHeight: '140%',
    letterSpacing: '0.02em',
    margin: theme.spacing(7, 0, 9),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(5, 0),
      width: '100%',
      textAlign: 'center',
    },
  },
  moduleNameRegistered: {
    fontStyle: 'italic',
    color: theme.palette.darkGrey.dark,
    fontFamily: 'Fancy Cut Pro',
    fontWeight: 400,
    fontSize: 48,
    lineHeight: '100%',
    letterSpacing: 0,
    margin: theme.spacing(6.5, 0, 6.5),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(5, 0, 2.5),
      width: '100%',
      textAlign: 'center',
    },
  },
  contentWrapper: {
    color: theme.palette.darkGrey.light,
  },
  tabletContentWrapper: {
    width: 'auto',
  },
  closeButton: {
    position: 'absolute',
    top: 2,
    right: 2,
    [theme.breakpoints.down('sm')]: {
      right: 10,
    },
  },
  arrowButton: {
    position: 'absolute',
    top: 4,
    left: 4,
    [theme.breakpoints.down('sm')]: {
      left: 10,
    },
  },
  backIcon: {
    width: '0.9em',
    height: '0.9em',
    color: theme.palette.lightGrey.main,
  },
  closeIcon: {
    color: theme.palette.lightGrey.main,
  },
}));

const contentTypes = {
  workshop: Workshop,
  meeting: Meeting,
  requests: MeetingRequest,
};

const EventScheduleShow = ({
  type, showHeader, goToPreviousSubpage: dispatchGoToPreviousSubpage,
  attendeeWorkshops, entities,
  setActiveWorkshop: dispatchSetActiveWorkshop,
  goToWorkshops: dispatchGoToWorkshops,
  ...props
}) => {
  const classes = useStyles();
  // const { t } = useTranslation('schedule');
  const Content = contentTypes[type];
  const theme = useTheme();
  const tablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className={classes.root}>
      {showHeader && (
        <div className={classes.header}>
          <BackButton />
          {/* <Typography
            className={classes.moduleNameRegistered}
            variant="subtitle1"
          >
            Detail
          </Typography> */}
        </div>
      )}
      <div className={clsx(classes.contentWrapper,
        tablet && classes.tabletContentWrapper)}
      >
        <Content {...props} />
      </div>
    </div>
  );
};

EventScheduleShow.propTypes = {
  type: PropTypes.string.isRequired,
  showHeader: PropTypes.bool.isRequired,
  goToPreviousSubpage: PropTypes.func.isRequired,
  entities: CustomPropTypes.entities.isRequired,
  attendeeWorkshops: PropTypes.objectOf(
    CustomPropTypes.attendeeWorkshops
  ),
  workshop: CustomPropTypes.workshop.isRequired,
  setActiveWorkshop: PropTypes.func.isRequired,
  goToWorkshops: PropTypes.func.isRequired,
};

EventScheduleShow.defaultProps = {
  attendeeWorkshops: {},
};

const mapStateToProps = ({
  app: {
    activeSubpage: {
      speakerId,
      activeSurvey,
    },
  },
  entities,
  entities: {
    attendeeWorkshops,
  },
}) => ({
  showHeader: !(speakerId || activeSurvey),
  entities,
  attendeeWorkshops,
});

export default connect(
  mapStateToProps, { goToPreviousSubpage, setActiveWorkshop, goToWorkshops }
)(EventScheduleShow);
